import React from 'react';
import { FloatingDots } from '../FloatingDots';
import { useIsMobile } from '../../hooks/useIsMobile';

/**
 * PageLayout - Reusable layout component with floating dots animation
 * Reduces code duplication across multiple pages
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Page content
 * @param {string} props.primaryColor - Primary color for dots (default: 'orange')
 * @param {string} props.secondaryColor - Secondary color for dots (default: 'green')
 * @param {number} props.desktopDots - Number of dots on desktop (default: 260)
 * @param {number} props.mobileDots - Number of dots on mobile (default: 120)
 */
export const PageLayout = ({ 
  children, 
  primaryColor = 'orange', 
  secondaryColor = 'green',
  desktopDots = 260,
  mobileDots = 120
}) => {
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden">
      {/* Floating Dots Animation */}
      <FloatingDots 
        count={isMobile ? mobileDots : desktopDots} 
        primaryColor={primaryColor} 
        secondaryColor={secondaryColor} 
      />
      
      {/* Page Content */}
      {children}
    </div>
  );
};
